// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3Us1w","info":"Note_info__3OzFm","note":"Note_note__D7CoX","actions":"Note_actions__3p5rT"};